import axiosInstance from './axiosInstance';

export const getProfile = async () => {
  const response = await axiosInstance.get('/user/profile');
  return response.data;
};

export const updateProfile = async (data) => {
  const response = await axiosInstance.put('/user/profile', data);
  return response.data;
};

export const changePassword = async (data) => {
  const response = await axiosInstance.put('/user/change-password', data);
  return response.data;
};

export const getAddresses = async () => {
  const response = await axiosInstance.get('/user/addresses');
  return response.data;
};

export const addAddress = async (data) => {
  const response = await axiosInstance.post('/user/addresses', data);
  return response.data;
};

export const deleteAddress = async (addressId) => {
  const response = await axiosInstance.delete(`/user/addresses/${addressId}`);
  return response.data;
};

export const setDefaultAddress = async (addressId) => {
  const response = await axiosInstance.put(`/user/addresses/${addressId}/default`);
  return response.data;
};

export const getNotifications = async () => {
  const response = await axiosInstance.get('/notifications');
  return response.data;
};

export const getUnreadCount = async () => {
  const response = await axiosInstance.get('/notifications/unread-count');
  return response.data;
};

export const markNotificationAsRead = async (notificationId) => {
  const response = await axiosInstance.put(`/notifications/${notificationId}/read`);
  return response.data;
};

export const markAllNotificationsAsRead = async () => {
  const response = await axiosInstance.put('/notifications/read-all');
  return response.data;
};

export const getWishList = async () => {
  const response = await axiosInstance.get('/wishlist');
  return response.data;
};

export const addToWishList = async (productId) => {
  const response = await axiosInstance.post(`/wishlist/add/${productId}`);
  return response.data;
};

export const removeFromWishList = async (productId) => {
  const response = await axiosInstance.delete(`/wishlist/remove/${productId}`);
  return response.data;
};